import context from '../context'
import { headerTypes } from '@/components/report-tables/enums/headerTypes'

const initialState = {
  loading: false,
  reportDetail: null
}

const actionTypes = {
  contentLoading: 'submittedReport/loading',
  contentLoaded: 'submittedReport/loaded',
  getSubmittedReportDetail: 'submittedReport/getSubmittedReportDetail'
}

const actionCreators = {
  getSubmittedReportDetail: (id) => (dispatch) => {
    dispatch({ type: actionTypes.contentLoading })
    context.api.groupsSubmissionService.getReport(id)
      .then(response => {
        const gridData = {
          ...response,
          columns: {
            id: 0,
            name: 'root',
            order: 1,
            children: response.columns
          },
          rows: {
            id: 0,
            name: response.name,
            order: 1,
            type: headerTypes.Root,
            children: response.rows
          }
        }

        dispatch({ type: actionTypes.getSubmittedReportDetail, data: gridData })

        dispatch({ type: actionTypes.contentLoaded })
      }).catch(() => dispatch({ type: actionTypes.contentLoaded }))
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.contentLoading:
    {
      state = { ...state, loading: true }
      break
    }
    case actionTypes.contentLoaded:
    {
      state = { ...state, loading: false }
      break
    }
    case actionTypes.getSubmittedReportDetail:
    {
      state = { ...state, reportDetail: action.data }
      break
    }
    default:
    {}
  }
  return state
}

export { actionCreators, reducer }



// WEBPACK FOOTER //
// ./src/store/SubmittedReport.js